import { create } from 'zustand';
import type { MeResponse } from '@boatnav/schemas';
import { api, ApiError } from '../../lib/apiClient.js';

type AuthStatus = 'unknown' | 'anonymous' | 'authed';

interface AuthState {
  status: AuthStatus;
  me: MeResponse | null;
  refresh: () => Promise<void>;
  login: (email: string, password: string) => Promise<void>;
  register: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
}

// Set by the sync service to run the first-login merge without a circular import.
let onAuthenticated: (() => void) | null = null;
export function setOnAuthenticated(cb: () => void): void {
  onAuthenticated = cb;
}

export const useAuthStore = create<AuthState>((set) => ({
  status: 'unknown',
  me: null,

  refresh: async () => {
    try {
      const me = await api.me();
      set({ status: 'authed', me });
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) set({ status: 'anonymous', me: null });
      else set({ status: 'anonymous', me: null });
    }
  },

  login: async (email, password) => {
    await api.login(email, password);
    const me = await api.me();
    set({ status: 'authed', me });
    onAuthenticated?.();
  },

  register: async (email, password) => {
    await api.register(email, password);
    const me = await api.me();
    set({ status: 'authed', me });
    onAuthenticated?.();
  },

  logout: async () => {
    await api.logout().catch(() => undefined);
    set({ status: 'anonymous', me: null });
  },
}));
